import * as React from 'react';
import type {SxProps} from '@mui/material';
import {FlexBox} from '../layout';
import {Text} from '../text';
import {IconTool} from '../toolbar';

type Props = {
  previousOnClick: () => void;
  previousDisabled: boolean;
  nextOnClick: () => void;
  nextDisabled: boolean;
  indicatorText: React.ReactNode;
};

const wrapperSx: SxProps = {
  textWrap: 'nowrap',
};

export const Paginator: React.FC<Props> = ({
  previousDisabled,
  previousOnClick,
  nextDisabled,
  nextOnClick,
  indicatorText,
}) => {
  return (
    <FlexBox
      alignItems={'center'}
      horizontal
      alignContent={'center'}
      justifyContent={'center'}
      sx={wrapperSx}>
      <IconTool
        icon="DropDown"
        rotate={90}
        onClick={previousOnClick}
        disabled={previousDisabled}
      />
      <Text kind="primary" variant={'h3'} component={'span'} sx={{pt: '3px'}}>
        {indicatorText}
      </Text>
      <IconTool
        icon="DropDown"
        onClick={nextOnClick}
        rotate={270}
        disabled={nextDisabled}
      />
    </FlexBox>
  );
};
